import axios from "axios";
import { getToken } from "../hooks/useAuth";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default instance;
